import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router';
import styled from 'styled-components';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

// import Sidebar from 'components/Sidebar';
import Navbar from 'components/Navbar';
import PredictionCatalogue from 'pages/Prediction/catalogue';
import Prediction from 'pages/Prediction';
import History from 'pages/History';
import RoundDetails from 'components/History/RoundDetails';
import ClaimAll from 'components/History/ClaimAll';
/* eslint-disable no-unused-vars */
import Referrals from 'pages/Referrals';
import Social from 'pages/Social';
import FAQ from 'pages/FAQ/index';
/* eslint-enable no-unused-vars */
import NotFound from 'pages/NotFound.js';
import { IsMobile } from 'utils/Mobile';
import { GetStoredLocalCurrencyPreference } from 'utils/Currency';
import { MobileContext, CurrencyContext } from 'context';
import { DOMAIN_NAME } from 'const';
import { HandleReferralParams } from 'utils/Referrals';
import { HandleLastBetParams } from 'utils/LastBet';
import HandleThemeOverrideParams from 'utils/Overrides';
import AboutUs from 'pages/About';

import 'styles/theme.scss';


const Pages = styled.div`
  width: 100vw;
  height: 100%;
`;


/*
const Pages = styled.div`
  width: 100vw;
  height: calc(100 * var(--vh-true));
  display: flex;
  justify-content: center;
  align-items: center;
`;
*/

function App() {
  const location = useLocation();
  const [isMobile, SetWhetherDeviceIsMobile] = useState(IsMobile());
  const [currencyID, SetCurrencyID] = useState(GetStoredLocalCurrencyPreference());
  //const [wantedChain, SetWantedChain] = useStateWithSessionStorage('wantedChain');


  useEffect(() => {
    UpdateTrueVH();
    AddScreenEventListeners();
    HandleReferralParams();
    HandleLastBetParams();
    HandleThemeOverrideParams();
    return () => {
      RemoveScreenEventListeners();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps


  function AddScreenEventListeners() {
    window.addEventListener('resize', HandleWindowSizeChange);
    // thanks to Apple(and MS' IE) there is no consistency in how to detect orientation change
    // and some ways have been known to crash the whole React app on Apple browsers
    try {
      if (!window.screen.orientation)
        window.addEventListener('orientationchange', HandleWindowSizeChange); // Safari
      else
        window.screen.orientation.addEventListener('change', HandleWindowSizeChange); // any other browser
    } catch (error) {
      if (error instanceof TypeError)
        return;
      else
        console.error(error);
    }
  }

  function RemoveScreenEventListeners() {
    window.removeEventListener('resize', HandleWindowSizeChange);
    try {
      if (!window.screen.orientation)
        window.removeEventListener('orientationchange', HandleWindowSizeChange); // Safari
      else
        window.screen.orientation.removeEventListener('change', HandleWindowSizeChange); // any other browser
    } catch (error) {
      if (error instanceof TypeError)
        return;
      else
        console.error(error);
    }
  }

  function HandleWindowSizeChange() {
    SetWhetherDeviceIsMobile(IsMobile());
    UpdateTrueVH();
  };

  // Why? Because I fucking hate you, Apple. Fuck you, Apple.
  // And FUCK YOU, Google Chrome dev team. Who copied after Apple's FUCKING BUGS!!
  // Because "Safari’s been doing this for years without user/developer complaint"
  // Fuck you very much, you two teams of monkeying assholes.
  function UpdateTrueVH() {
    document.querySelector('html').style.setProperty('--vh-true', window.innerHeight / 100 + 'px');
  }

  return (
      <MobileContext.Provider value={isMobile}>
        <CurrencyContext.Provider value={{ currencyID: currencyID, SetCurrencyID: SetCurrencyID }}>
          <Navbar />

          {/* <Sidebar /> */}
          <ToastContainer />
          <Pages className='page-background'>

            <Routes>

              <Route
                path='/'
                element={<Navigate replace to={`/prediction/bsc/btc${location.search}`} />}
              />
              <Route path='/prediction' element={<PredictionCatalogue />} />

              {/* Legacy routes */}
              <Route
                path='/prediction/bnb'
                element={<Navigate replace to={`/prediction/bsc/bnb${location.search}`} />}
              />
              <Route
                path='/prediction/btc'
                element={<Navigate replace to={`/prediction/bsc/btc${location.search}`} />}
              />
              <Route
                path='/history/bnb'
                element={<Navigate replace to={`/history/bsc/bnb${location.search}`} />}
              />
              <Route
                path='/history/btc'
                element={<Navigate replace to={`/history/bsc/btc${location.search}`} />}
              />
              {/* end of Legacy routes */}

              <Route path='/prediction/bsc/bnb' element={<Prediction />} />
              <Route path='/prediction/bsc/btc' element={<Prediction />} />
              {/*<Route path='/prediction/dogechain/doge' component={Prediction} />*/}
              {/*<Route path='/prediction/dogechain/btc' component={Prediction} />*/}

              <Route path='/history/bsc/bnb' element={<History />} />
              <Route path='/history/bsc/bnb/round/:id' element={<RoundDetails />} />
              <Route path='/history/bsc/bnb/claimall' element={<ClaimAll />} />

              <Route path='/history/bsc/btc' element={<History />} />
              <Route path='/history/bsc/btc/round/:id' element={<RoundDetails />} />
              <Route path='/history/bsc/btc/claimall' element={<ClaimAll />} />

              {/*<Route path='/history/dogechain/doge' component={History} />*/}
              {/*<Route path='/history/dogechain/btc' component={History} />*/}

              <Route path='/referrals/bsc' element={<Referrals />} />
              <Route path='/referrals/dogechain' element={<Referrals />} />

              <Route path='/faq' element={<FAQ />} />
              <Route path='/about' element={<AboutUs />} />
              <Route path='/social' element={<Social />} />

              {/*<Route path='/live-events' component={() => {
                  window.location.href = 'https://live-events.' + DOMAIN_NAME;
                  return null;
                }} />*/}
              {/*<Route path='/exchange' component={ExchangePage} />*/}
              <Route path="*" element={<NotFound />} />
              {/*
                
                <Route path='/lottery' component={Lottery} />
                */}
            </Routes>
          </Pages>
          {/* <Footer /> */ /* This is more trouble than it's worth. Keeps getting stuck in the middle of page */}
        </CurrencyContext.Provider>
      </MobileContext.Provider>
  );
}

export default App;
